import axios from '@axios'

const route = 'financial/bills_to_pay'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAll(context, {
      itemsPerPage, page, filters, search, status, date,
    }) {
      return axios.post(
        `${route}/index` + `?page=${page}&items_per_page=${itemsPerPage}`,

        filters,
      )
    },

    store(context, billsToPay) {
      return axios.post(route, billsToPay)
    },

    update(context, billsToPay) {
      if (billsToPay instanceof FormData) {
        return axios.post(`${route}/${billsToPay.get('id')}`, billsToPay)
      }
      return axios.put(`${route}/${billsToPay.id}`, billsToPay)
    },

    destroy(context, billsToPay) {
      return axios.delete(`${route}/${billsToPay.id}`)
    },

    getSupplier(context, searchKeyWordSupplier) {
      return axios.get(`${route}/get_suppliers?search=${searchKeyWordSupplier}`)
    },

    // pagar contas
    payBills(context, bills) {
      return axios.post(`${route}/pay_bills`, { bills })
    },

    exportExcel(context, filters) {
      return axios.post(`${route}/export_excel`, filters, { responseType: 'blob' })
    },

    pay(context, bills) {
      return axios.post(`${route}/pay`, bills)
    },
    cancel(context, bill) {
      return axios.post(`${route}/cancel/${bill.id}`)
    },
    recycle(context, bill) {
      return axios.post(`${route}/recycle/${bill.id}`)
    },
    getDownloadAttach(context, bill) {
      return axios.get(`${route}/download_attach/${bill.id}`, { responseType: 'blob' })
    },
    downloadAttachFile(context, { billId, attachmentId }) {
      return axios.get(`${route}/download_attach/${attachmentId}`, { responseType: 'blob' })
    },
    saveCategory(context, category) {
      return axios.post('financial/bill_categories', category)
    },
  },
}
